import { useSelector } from 'react-redux';

import { useActions } from '@mssgme/hooks';
import { getConversation } from '@mssgme/store';

export default function useClientCard(contactId) {
    const actions = useActions();
    const contact = useSelector((state) => getConversation(state, contactId).contact);

    const onSubmit = (payload) => actions.api.contacts.update({ contactId, payload });

    return {
        contact,
        onSubmit,
    };
}
